/* Convx 848 (2026-09-17): sticky bar "Select Size" sheet.
   Selection, disabling and add-to-cart are all the theme's own machinery (product-variants, product-form,
   product-payment-container) bound to the main product form. This file only:
   1. keeps the "· UK 6" size readout in the sticky bar in step with the selected variant,
   2. closes the sheet once the form reports variant:added,
   3. pushes the ATC-1 measurement events to the dataLayer (atc_size_prompt_shown / selected / dismissed / added). */
(function () {
  'use strict';

  function init() {
    var sheet = document.getElementById('StickySizeSheet');
    var bar = document.querySelector('product-sticky-form');
    if (!sheet || !bar) return;

    var form = document.getElementById(sheet.getAttribute('form-id'));
    var sizeIndex = parseInt(sheet.getAttribute('data-size-option-index'), 10);
    var readout = bar.querySelector('.product-sticky-form__variant');
    var selectedInSheet = false;

    function push(name, extra) {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: name, product_handle: sheet.getAttribute('data-product-handle') };
      if (extra) { for (var k in extra) { payload[k] = extra[k]; } }
      window.dataLayer.push(payload);
    }

    function updateReadout(variant) {
      if (!readout) return;
      var size = variant && variant.options && !isNaN(sizeIndex) ? variant.options[sizeIndex] : null;
      if (size) {
        readout.textContent = (readout.getAttribute('data-prefix') || '') + size;
        readout.hidden = false;
      } else {
        readout.hidden = true;
      }
    }

    if (form) {
      form.addEventListener('variant:changed', function (e) {
        updateReadout(e.detail && e.detail.variant);
      });
      form.addEventListener('variant:added', function () {
        if (sheet.hasAttribute('open')) {
          // removeAttribute rather than the .open setter, so this works even before theme.js upgrades the element
          sheet.removeAttribute('open');
          push('atc_size_prompt_added');
        }
      });
    }

    sheet.addEventListener('openable-element:open', function () {
      selectedInSheet = false;
      push('atc_size_prompt_shown');
    });
    sheet.addEventListener('openable-element:close', function () {
      if (!selectedInSheet) push('atc_size_prompt_dismissed');
    });
    // Only count selections the shopper made in the sheet. The theme echoes page-picker changes into the
    // sheet's radios (programmatic change events), so a change counts only if a touch, pointer or key landed
    // on the sheet in the last 0.8s.
    var lastTouch = 0;
    ['pointerdown', 'touchstart', 'keydown'].forEach(function (type) {
      sheet.addEventListener(type, function () { lastTouch = Date.now(); }, { passive: true });
    });
    sheet.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name && t.name.indexOf('option') === 0 && Date.now() - lastTouch < 800) {
        selectedInSheet = true;
        push('atc_size_prompt_selected', { option_name: t.name, option_value: t.value });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
